const shell = {
  projectSyncError: '기업 프로젝트를 불러오지 못했습니다. 네트워크를 확인한 후 다시 시도해 주세요.',
  retry: '다시 시도',
  projectSwitcher: '프로젝트 전환',
  switchWorkspace: '기업 공간 전환',
  home: 'Navigator 홈',
  project: '프로젝트',
  currentProject: '현재 프로젝트',
  newProject: '새 프로젝트',
  navigation: '기본 탐색',
  nav: {
    memory: '메모리',
    diagnosis: '진단',
    action: '실행',
    presence: '채널',
    results: '성과',
  },
  appearance: '화면 모드',
  themeButtonLabel: '화면 모드 · {theme}',
  settings: '설정',
  settingsIntro: '인터페이스, 기업 공간 및 프로젝트 환경설정을 관리합니다.',
  personal: '개인',
  workspace: '기업 공간',
  projectSettings: '프로젝트',
  interfaceLanguage: '인터페이스 언어',
  interfaceLanguageHint: 'Navigator 조작 화면만 변경합니다. 기업 정보와 증거 원문은 그대로 유지됩니다.',
  followSystem: '시스템 설정 사용',
  theme: '테마',
  themeSystem: '시스템',
  themeLight: '라이트',
  themeDark: '다크',
  close: '닫기',
  vaultConnected: '프로젝트 공간 준비 완료',
  workspaceSettingsIntro: '이 기업이 공유하는 공간 환경설정을 관리합니다.',
  membersEyebrow: '기업 공간 접근 제어',
  membersTitle: '구성원 및 권한',
  membersIntro: '기업 공간에 들어올 수 있는 업무용 이메일과 각 구성원의 역할을 관리합니다.',
  membersScope: '권한은 현재 기업 공간의 모든 프로젝트에 적용됩니다.',
  activeMembers: '명의 활성 구성원',
  memberRoles: { tenant_admin: '기업 관리자', operator: '운영 담당자', member: '구성원' },
  memberRoleShort: {
    tenant_admin: '구성원, 설정 및 모든 운영 업무를 관리합니다.',
    operator: '리드를 검토하고 담당자를 배정하며 후속 조치를 기록합니다.',
    member: '기업 프로젝트를 사용하고 배정된 업무를 처리합니다.',
  },
  memberRoleDetail: {
    tenant_admin: '구성원과 설정을 관리하고 운영 화면에서 다른 구성원에게 리드를 배정할 수 있습니다.',
    operator: '운영 화면에서 리드를 검토하고 활성 구성원에게 배정할 수 있습니다.',
    member: '기업 프로젝트를 사용하고 본인에게 배정된 업무를 처리할 수 있으며 구성원 관리는 할 수 없습니다.',
  },
  memberStatuses: { active: '활성', revoked: '비활성' },
  memberList: '기업 구성원',
  memberFilter: '구성원 필터',
  addMember: '구성원 추가',
  manageMember: '관리',
  currentAccount: '현재 계정',
  noMembers: '이 상태의 구성원이 없습니다.',
  membersLoading: '기업 구성원을 불러오는 중…',
  membersLoadFailed: '기업 구성원을 불러오지 못했습니다.',
  memberBoundaryTitle: 'V1 권한 범위:',
  memberBoundaryBody: '기업 공간 접근만 관리합니다. 부서 또는 프로젝트별 권한은 포함하지 않습니다. 비활성화하면 기존 세션도 즉시 종료됩니다.',
  memberPermissionTitle: '기업 관리자만 구성원을 관리할 수 있습니다.',
  memberPermissionBody: '현재 접근 권한은 변경되지 않습니다.',
  addMemberTitle: '기업 구성원 추가',
  addMemberIntro: '업무용 이메일을 현재 기업 공간에 추가합니다.',
  editMemberTitle: '구성원 관리',
  editMemberIntro: '역할 변경은 저장 즉시 적용됩니다.',
  workEmail: '업무용 이메일',
  memberEmailHint: '추가된 이메일은 로그인 화면에서 일회용 보안 링크를 요청할 수 있습니다.',
  accessRole: '접근 권한',
  memberLastAdminTitle: '마지막 관리자는 강등하거나 비활성화할 수 없습니다.',
  memberLastAdminBody: '먼저 다른 기업 관리자를 추가하세요.',
  memberSelfGuard: '현재 관리자는 자신의 접근 권한을 변경할 수 없습니다.',
  deactivateMember: '접근 비활성화',
  restoreMember: '접근 복원',
  saveMember: '변경 저장',
  savingMember: '저장 중…',
  cancel: '취소',
  memberAdded: '구성원이 추가되었습니다.',
  memberSaved: '구성원 권한이 업데이트되었습니다.',
  memberRevoked: '구성원 접근이 비활성화되었습니다.',
  memberRestored: '구성원 접근이 복원되었습니다.',
  memberExists: '이미 기업 공간에 등록된 이메일입니다.',
  memberSaveFailed: '구성원 변경을 저장하지 못했습니다.',
  projectSettingsIntro: '현재 프로젝트에만 적용되는 환경설정을 관리합니다.',
  defaultOutputLanguage: '기본 작업 및 보고서 언어',
  defaultOutputLanguageHint: '진단 보고서, 전략 및 기타 프로젝트 AI 호출에 구체적인 output_language 값으로 전송됩니다. 인터페이스 언어는 변경하지 않습니다.',
  targetContentLanguages: '대상 콘텐츠 언어',
  targetContentLanguagesHint: '시장 대상 제작 언어를 하나 이상 선택합니다. 개별 작업에서는 프로젝트 기본값을 재정의할 수 있습니다.',
  saveLanguageSettings: '언어 설정 저장',
  savingLanguageSettings: '저장 중…',
  languageSettingsSaved: '저장됨',
  languageSettingsFailed: '저장하지 못했습니다. 운영 설정은 이전 값으로 유지됩니다.',
  leadSlaTenantTitle: '기업 리드 응답 규칙',
  leadSlaTenantHint: '기업 프로젝트가 기본으로 사용할 리드 응답 기한을 설정합니다. 프로젝트에서 상속, 재정의 또는 비활성화할 수 있습니다.',
  leadSlaProjectTitle: '프로젝트 리드 응답 규칙',
  leadSlaProjectHint: '기업 규칙을 상속할지, 독립 규칙을 사용할지, 이후 타이머를 비활성화할지 선택합니다.',
  leadSlaLoading: '현재 응답 규칙을 불러오는 중…',
  leadSlaEffective: '현재 적용',
  leadSlaEnabled: '활성',
  leadSlaDisabled: '비활성',
  leadSlaEffectiveSource: '출처: {source} · 규칙 revision {revision}',
  leadSlaSourceTenant: '기업 규칙',
  leadSlaSourceProject: '프로젝트 규칙',
  leadSlaSourceNone: '규칙 없음',
  leadSlaMode: '현재 범위',
  leadSlaModes: { policy: '독립 규칙 사용', disabled: '비활성화', inherit: '기업 규칙 상속' },
  leadSlaClockMode: '시간 계산 방식',
  leadSlaClockElapsed: '연속 시간',
  leadSlaClockBusiness: '업무 시간만',
  leadSlaTimezone: '시간대',
  leadSlaFirstResponse: '첫 응답(분)',
  leadSlaFollowup: '후속 조치(분)',
  leadSlaWarning: '사전 알림(분)',
  leadSlaBusinessDays: '업무일',
  leadSlaWeekdays: { 0: '월', 1: '화', 2: '수', 3: '목', 4: '금', 5: '토', 6: '일' },
  leadSlaBusinessStart: '시작 시간',
  leadSlaBusinessEnd: '종료 시간',
  leadSlaAdminOnly: '기업 관리자만 이 설정을 변경할 수 있습니다.',
  leadSlaValidation: '모든 규칙을 입력하세요. 알림 시간은 두 응답 기한보다 짧아야 합니다.',
  leadSlaSave: '응답 규칙 저장',
  leadSlaSaving: '저장 중…',
  leadSlaSaved: '응답 규칙을 저장했습니다',
  leadSlaSaveFailed: '저장하지 못했습니다. 현재 규칙을 다시 불러온 뒤 시도하세요.',
  leadSlaUnavailable: '현재 응답 규칙을 불러오지 못했습니다.',
  leadSlaNoScope: '현재 기업 또는 프로젝트를 아직 사용할 수 없습니다.',
  leadSlaClockBoundary: '설정 변경은 진행 중인 타이머를 바꾸지 않습니다. 현재 단계는 시작 시 규칙으로 마감되며, 비활성화 후에는 다음 단계를 시작하지 않고, 상속 후의 다음 단계는 그 시점의 기업 규칙을 사용합니다.',
  airlockAppearance: '웹사이트 Airlock 모양',
  airlockAppearanceHint: '고객 웹사이트에 설치되는 안내 모듈의 모양을 설정합니다. Navigator 화면에는 영향을 주지 않습니다.',
  airlockLoading: '현재 웹사이트 모양을 불러오는 중…',
  airlockPreviewEyebrow: '웹사이트 안내',
  airlockPreviewTitle: '무엇을 도와드릴까요?',
  airlockPreviewBody: '저장하기 전에 허용된 색상, 모서리와 글꼴을 미리 봅니다.',
  airlockPreviewAction: '대화 시작',
  airlockColorScheme: '라이트·다크 모드',
  airlockScheme: { auto: '방문자 기기 설정 따르기', light: '항상 라이트', dark: '항상 다크' },
  airlockColors: '브랜드 색상',
  airlockColorsHint: '“웹사이트 기본값”을 유지하면 검증된 안전 기본값을 사용합니다.',
  airlockAccent: '주요 동작',
  airlockOnAccent: '주요 동작의 글자',
  airlockSurface: '기본 배경',
  airlockSurfaceAlt: '보조 배경',
  airlockText: '기본 글자',
  airlockMuted: '보조 글자',
  airlockLine: '테두리와 구분선',
  airlockInherit: '웹사이트 기본값',
  airlockUseDefault: '기본값 사용',
  airlockCornerRadius: '모서리 둥글기',
  airlockFont: '글꼴',
  airlockFontHost: '웹사이트 따르기',
  airlockFontSans: 'Navigator Sans',
  airlockFontSerif: 'Navigator Serif',
  airlockSave: 'Airlock 모양 저장',
  airlockSaving: '저장 중…',
  airlockSaved: '웹사이트 모양을 저장했습니다',
  airlockSaveFailed: '저장하지 못했습니다. 현재 설정을 다시 불러온 뒤 시도하세요.',
  airlockUnavailable: '이 프로젝트에서는 아직 웹사이트 모양 설정을 사용할 수 없습니다.',
  airlockRetry: '다시 시도',
  airlockBoundary: '허용된 색상, 모서리, 글꼴과 표시 모드만 입력할 수 있습니다. CSS, URL, 스크립트는 입력할 수 없습니다.',
  subscription: '구독 및 결제',
  billingLoading: '구독 상태를 불러오는 중…',
  billingUnavailable: '현재 구독 결제 서비스를 사용할 수 없습니다.',
  billingEyebrow: 'Navigator billing · Stripe Sandbox',
  billingTitle: '요금제 및 구독',
  billingIntro: '이 기업 공간의 지속 운영 용량을 선택합니다. Navigator의 기능은 계속 진화하며 요금제는 고정 기능 목록이 아닌 사용 용량을 정합니다.',
  billingSandbox: '테스트 모드 · 실제 청구 없음',
  billingEnterprise: '결제 대상 기업 공간',
  billingCurrent: '현재 구독',
  billingStatus: {
    AWAITING_PAYMENT: '결제 대기',
    ACTIVE: '활성',
    CANCEL_AT_PERIOD_END: '이번 기간 후 종료',
    PAST_DUE: '결제 연체',
    EXPIRED: '만료',
    REFUNDED: '환불됨',
  },
  billingPeriodEnd: '현재 기간 종료일: {date}',
  billingNoSubscription: '이 기업 공간에는 아직 활성 구독이 없습니다.',
  billingInterval: '결제 주기',
  billingMonthly: '월간 결제',
  billingAnnual: '연간 결제',
  billingAnnualPromo: '10개월 가격으로 12개월 이용',
  billingPlan: {
    launch: '지속적인 성장 순환을 시작하는 소규모 팀용.',
    growth: '시장과 업무 순환을 확장하는 성장 팀용.',
    scale: '더 큰 규모와 복잡한 협업을 운영하는 조직용.',
    enterprise: '가격, 배포 범위 및 서비스 조건을 계약으로 별도 합의합니다.',
  },
  billingMonthUnit: '월',
  billingYearUnit: '년',
  billingStartCheckout: '안전 결제로 이동',
  billingRedirecting: '결제 화면 여는 중…',
  billingCustom: '별도 견적',
  billingContractOnly: '문의하기',
  billingAdminOnly: '기업 공간 관리자만 구독을 시작할 수 있습니다.',
  billingExistingGuard: '이 공간에는 이미 구독이 있습니다. Sandbox 단계에서는 요금제 변경 및 해지를 지원하지 않습니다.',
  billingCheckoutFailed: '결제 화면을 열지 못했습니다. 구독 상태는 변경되지 않았습니다.',
  billingBoundary: '테스트 환경 전용입니다. 기업 ID는 로그인한 Navigator 세션에서, 가격은 고정된 Sandbox 가격표에서 가져오며 브라우저에서 바꿀 수 없습니다.',
  billingUsageEyebrow: '용량 관찰',
  billingUsageTitle: '이번 기간의 비즈니스 사용량',
  billingUsageObserveOnly: '현재는 연구용 관찰값입니다. 참조값에 도달해도 서비스 중단, 다운그레이드, 자동 결제는 발생하지 않습니다.',
  billingUsageCounter: {
    completed_cycle: '완료 주기',
    standard_artifact: '표준 성과물',
    localization_version: '현지화 버전',
    publication_position: '신규 게시 위치',
    airlock_conversation: 'Airlock AI 대화',
  },
  billingUsageBreakdown: '사용 {used} · 진행 중 {inFlight} · 대기 {queued}',
  billingUsageNotConnected: '데이터 연결 안 됨',
  billingUsageNotConnectedDetail: '신뢰할 수 있는 비즈니스 소스가 연결된 후 실제 사용량이 표시됩니다.',
  billingUsageBoundary: '슬래시 뒤의 값은 Sandbox 관찰 기준이며, 고객 계약의 보장 한도가 아닙니다.',
  outputLanguageBoundary: '언어 선택은 Navigator가 소유합니다. Foundry는 호출마다 구체적인 BCP-47 output_language 하나를 받으며 전역 기본값을 정의하지 않습니다.',
  settingsBoundary: '이 패널에는 고객용 앱 설정과 기업 접근 권한을 둡니다. 내부 운영과 시스템 제어는 별도의 제어 화면에서 관리합니다.',
  settingsDeferred: '설정 진입점과 소유권 경계는 준비되었습니다. 세부 항목은 운영 계약 승인 후 연결합니다.',
  signedInAs: '로그인한 이메일',
  signOut: '로그아웃',
  signingOut: '로그아웃 중…',
  signOutFailed: '로그아웃하지 못했습니다. 연결을 확인하고 다시 시도하세요.',
  surfacePendingEyebrow: '글로벌 셸 · 화면 연결',
  surfacePendingTitle: '{route} 화면 연결 중',
  surfacePendingBody: '탐색, 언어 및 설정 경계가 준비되었습니다. 이 화면의 운영 콘텐츠는 해당 페이지 작업에서 연결합니다.',
} as const

export default shell
